// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarContent_wrapper__wJtK1","wrapper--wide":"SidebarContent_wrapper--wide__FzEf6","content":"SidebarContent_content__aZieH","header":"SidebarContent_header__UiIC+"};